module.exports = __webpack_public_path__ + "img/hiw-schema-ee.7d1079b6.png";